import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';
import {
  CARRY_DOCUMENT_STATUS_LABELS,
  CARRY_DOCUMENT_STATUSES,
} from '@/types/carryDocument';
import { ANY, type StatusFilter } from './carryDocumentStatus';

interface CarryDocumentStatusSelectProps {
  value: StatusFilter;
  onChange: (status: StatusFilter) => void;
  className?: string;
}

export function CarryDocumentStatusSelect({
  value,
  onChange,
  className,
}: CarryDocumentStatusSelectProps) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as StatusFilter)}>
      <SelectTrigger
        className={cn('w-full sm:w-[190px]', className)}
        aria-label="Filter by status"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ANY}>All statuses</SelectItem>
        {CARRY_DOCUMENT_STATUSES.map((status) => (
          <SelectItem key={status} value={status}>
            {CARRY_DOCUMENT_STATUS_LABELS[status]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
